<nz-spin [nzSpinning]="wiggleDataSource.isLoading()">
    <div #graphContainer>
    <svg #graph></svg>
    </div>
</nz-spin>
